import { createSlice } from '@reduxjs/toolkit';
import { resetAdminPersistedJourneyState } from 'store/adminJourneyReset';

export interface PayrollState {
  selectedProvider: string | null;
  validationStatus: string | null;
}

const initialState: PayrollState = {
  selectedProvider: null,
  validationStatus: null,
};

const payrollSlice = createSlice({
  name: 'payroll',
  initialState,
  reducers: {
    setSelectedProvider(state, action: { payload: string | null }) {
      state.selectedProvider = action.payload;
    },
    setPayrollValidationStatus(state, action: { payload: string | null }) {
      state.validationStatus = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetAdminPersistedJourneyState, () => ({ ...initialState }));
  },
});

export const { setSelectedProvider, setPayrollValidationStatus } = payrollSlice.actions;
export default payrollSlice.reducer;
